module.exports = __webpack_public_path__ + "static/media/WhatsappNearby.cf20c60d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/WhatsappNearby.png
// module id = 457
// module chunks = 0